import RichText from '@quno/patient-journey/src/components/ui/ContentBlocks/RichText';
import { useEffect, useState } from 'react';
import { getRichTextMultilocale } from '@quno/onboarding/src/generator/configs/componentMapper';
import type { StringAttribute } from '@quno/onboarding/src/generator/types/generics/ModelAttributes';
import type { FormLocales } from '@quno/onboarding/src/constants/locales';
import type { CardProps } from '@quno/patient-journey/src/components/Card/card.config';
import type { Document } from '@contentful/rich-text-types';

export type TextCardProps = {
  text: StringAttribute;
  alignment?: 'left' | 'center' | 'right';
  locale: FormLocales;
};

export const TextCard = ({
  text,
  alignment = 'left',
  fontColorOverride,
  backgroundColorOverwrite,
  cardBorderRadius,
  locale,
}: Omit<CardProps, 'text'> & TextCardProps): JSX.Element => {
  const [textContent, setTextContent] = useState<Document | undefined>();

  useEffect(() => {
    const run = async (): Promise<void> => {
      const content = await getRichTextMultilocale(text, locale);
      setTextContent(content);
    };

    void run();
  }, [text, locale]);

  return (
    <div
      style={{
        textAlign: alignment,
        color: fontColorOverride || undefined,
        backgroundColor: backgroundColorOverwrite || 'transparent',
        borderRadius: cardBorderRadius || 0,
        padding: '1rem',
      }}
    >
      <div>
        <RichText
          fields={textContent}
          noWrapper
          style={
            {
              color: fontColorOverride,
              '--list-style-color': fontColorOverride,
            } as React.CSSProperties
          }
        />
      </div>
    </div>
  );
};
